export class SearchBuilderDeclarantByNameResultDto {
    ownerId: number;
    companyName: string;
    parentCompanyName: string;
    city: string;
    state: string;
    zip: string;
    rOwnerId: string;
}
